import React from 'react';
import { Spin, Tabs } from 'antd';

import useWizardSteps from 'hooks/useWizardSteps';
import { TabsProps } from 'antd/lib/tabs';
import { isNil, sortBy } from 'lodash';

const { TabPane } = Tabs;

export type WizardTabsProps = TabsProps & {
  defaultTabs?: string[];
  entity: string;
  entityid?: number;
  hiddenTabs?: string[];
  tabs: Record<string, React.ReactChild>;
  taskid?: number;
  tabPosition?: string;
  disabled?: any;
  className?: string;
};

const WizardTabs = ({
  defaultTabs,
  entity,
  entityid,
  hiddenTabs,
  tabs,
  taskid,
  tabPosition,
  disabled,
  className,
  ...otherProps
}: WizardTabsProps) => {
  const steps = useWizardSteps({ entity, entityid, taskid }, defaultTabs);
  const filteredSteps = hiddenTabs
    ? steps?.filter((step) =>
        step.funcode ? !hiddenTabs.includes(step.funcode) : true
      )
    : steps;

  const tabPositionFinal =
    tabPosition ?? (localStorage.getItem('tabposition') as any);

  const sortedSteps = sortBy(filteredSteps, 'steporder');

  return (
    <Spin
      spinning={isNil(steps)}
      size="default"
      style={{
        position: 'fixed',
        top: '40%',
      }}
    >
      <Tabs
        {...otherProps}
        tabPosition={tabPositionFinal ?? 'left'}
        type="line"
        style={{ padding: '10 80 80 10' }}
        className={className ?? ''}
      >
        {sortedSteps?.map((step) => (
          <TabPane
            tab={step.steplabel}
            key={step.funcode}
            forceRender
            disabled={disabled}
          >
            {tabs[step.funcode ?? '']}
          </TabPane>
        ))}
      </Tabs>
    </Spin>
  );
};

export default WizardTabs;
